"use strict";

exports.__esModule = true;
exports.default = void 0;

var _formRow = _interopRequireDefault(require("../layout/form-row"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _formRow.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/form/form-row.js
// module id = I7Xz
// module chunks = 0